import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import store from '../config/redux-store';
import { updateAppState } from '../store/actions/app';
import { CustomObject } from '../types/data';

const { dispatch } = store;

abstract class LoaderService {
  static loaders: CustomObject = {};
  static groups: CustomObject = {};
  static nextId: number = 1;

  static show(id?: number | string) {
    if (isEmpty(this.loaders)) {
      // show loader
      dispatch(
        updateAppState({
          showLoader: true,
        })(dispatch)
      );
    }

    const key = id || this.nextId++;

    this.loaders[key] = true;

    return key;
  }

  static hide(id?: number | string) {
    return new Promise((resolve, reject) => {
      if (isNumber(id) || !!id) {
        delete this.loaders[id];
      } else {
        this.loaders = {};
      }

      if (isEmpty(this.loaders)) {
        // hide loader

        // if (store.getState().ui.pageLoader) {
        dispatch(
          updateAppState({
            showLoader: false,
          })(dispatch)
        );
        // }

        resolve();
      }
    });
  }

  static getGroup(groupName: string) {
    return this.groups[groupName];
  }

  static addToGroup(id: number | string, groupName: string) {
    if (!this.groups[groupName]) {
      this.groups[groupName] = [];
    }

    return this.groups[groupName].push(id);
  }

  static hideGroup(groupName: string) {
    const group: number[] = this.groups[groupName];

    if (group) {
      group.map(id => this.hide(id));
      delete this.groups[groupName];
    } else {
      this.hide(groupName);
    }
  }
}

export default LoaderService;
